import { cancellableRequest } from './request';

const AuthService = {
    login: (data) => cancellableRequest({ method: 'post', url: '/auth/login', data }),
    reset: (data) => cancellableRequest({ method: 'post', url: '/auth/reset', data }),
    checkResetToken: (token) =>
        cancellableRequest({ method: 'get', url: '/auth/reset', headers: { Authorization: `Bearer ${token}` } }),
    setNewPassword: (data, token) =>
        cancellableRequest({
            method: 'put',
            url: '/auth/reset',
            data,
            headers: { Authorization: `Bearer ${token}` },
        }),
    signup: (data) => cancellableRequest({ method: 'post', url: '/auth/signup', data }),
};

export { AuthService };
